<template>
    <uw-page title="团队管理">
        <template slot="header-suffix">
            <projects-flow-reset-task :project-id="projects_id" @onChange="TeamSearch" />
            <el-button type="primary" size="mini" @click="$refs.user.Open()">添加成员</el-button>
        </template>
        <vxe-table ref="xTable" :data="team" :loading="loading" height="100%">
            <vxe-column width="50" type="seq" title="ID"></vxe-column>
            <vxe-column width="150" field="name" title="成员">
                <template #default="{ row }">
                    <div style="display: flex; align-items: center; justify-content: flex-start;">
                        <el-avatar style="margin-right: 5px;" :size="26" :src="row.user?.avatar">{{ row.user?.name[0] }}</el-avatar>
                        {{  row.user?.name }}
                    </div>
                </template>
            </vxe-column>
            <vxe-column width="120" field="role" title="角色">
                <template #default="{ row }">
                    <el-link :underline="false" type="danger" v-if="row.role == 'admin'">管理员</el-link>
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                            <el-link icon="el-icon-setting" :underline="false" type="danger" v-if="row.role == 'leader'">项目经理</el-link>
                            <el-link icon="el-icon-setting" :underline="false" type="primary" v-if="row.role == 'affair'">商务</el-link>
                            <el-link icon="el-icon-setting" :underline="false" type="primary" v-if="row.role == 'presale'">售前</el-link>
                            <el-link icon="el-icon-setting" :underline="false" type="primary" v-if="row.role == 'sale'">销售</el-link>
                            <el-link icon="el-icon-setting" :underline="false" type="info" v-if="row.role == 'helper'">普通组员</el-link>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="updateRole(row.id, 'leader')">项目经理</el-dropdown-item>
                            <el-dropdown-item @click.native="updateRole(row.id, 'helper')">普通组员</el-dropdown-item>
                            <el-dropdown-item @click.native="updateRole(row.id, 'sale')">销售</el-dropdown-item>
                            <el-dropdown-item @click.native="updateRole(row.id, 'affair')">商务</el-dropdown-item>
                            <el-dropdown-item @click.native="updateRole(row.id, 'presale')">售前</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </vxe-column>
            <vxe-column width="120" field="money" title="人工计价/P">
                <template #default="{ row }">
                    <el-link :underline="false" type="warning" @click="$refs.userEditMoney.Open(projects_id, row.user_id, row.money)">￥{{ row.money }}</el-link>
                </template>
            </vxe-column>
            <vxe-column width="120" field="consume_days" title="成本统计">
                <template #default="{ row }">
                    ￥{{ row.money * (Number(row.task_day_consume) + Number(row.wo_day_consume)) }}
                </template>
            </vxe-column>
            <vxe-column width="120" field="projects_sum_day_consume" title="任务消耗/P">
                <template #default="{ row }">
                    <el-link :underline="false" icon="el-icon-pie-chart">
                        {{ row.task_day_consume }}
                    </el-link>
                </template>
            </vxe-column>
            <vxe-column width="120" field="wo_day_consume" title="工单消耗/P">
                <template #default="{ row }">
                    <el-link :underline="false" icon="el-icon-pie-chart">
                        {{ row.wo_day_consume }}
                    </el-link>
                </template>
            </vxe-column>
            <vxe-column width="120" title="小计/P">
                <template #default="{ row }">
                    <el-link :underline="false" type="primary" icon="el-icon-pie-chart" @click="$refs.workingDrawer.open({ projects_id: projects_id, users_id: row.user_id })">
                        {{ (Number(row.wo_day_consume) + Number(row.task_day_consume)).toFixed(2) }}
                    </el-link>
                </template>
            </vxe-column>
            <vxe-column width="160" field="created_at" title="加入日期">
                <template #default="{ row }">
                    <el-link icon="el-icon-time">{{ row.created_at }}</el-link>
                </template>
            </vxe-column>
            <vxe-column width="160" field="updated_at" title="更新日期">
                <template #default="{ row }">
                    <el-link icon="el-icon-time">{{ row.updated_at }}</el-link>
                </template>
            </vxe-column>
            <vxe-column width="80"  title="操作" align="center" fixed="right">
                <template #default="{ row }">
                    <el-link @click="TeamDelete(row.id)" type="danger">移除</el-link>
                </template>
            </vxe-column>
        </vxe-table>
        <hrm-employee-select-table ref="user" @onChange="UserChange" width="1080px" height="65%" multiple />
        <userEditMoney ref="userEditMoney" @onChange="TeamSearch()"></userEditMoney>
        <pm-working-drawer ref="workingDrawer" @onChange="TeamSearch()" />
    </uw-page>
</template>
<script>
import userEditMoney from '@/views/projects/DialogProjectsTeamEditMoney.vue'
export default {
    props: ['projects_id'],
    components: {
        userEditMoney,
    },
    data () {
        return {
                        loading: false,
                        team: [],
        }
    },
    watch: {
        projects_id: {
            handler (val) {
                if (val) {
                    this.TeamSearch()
                }
            },
            immediate: true
        }
    },
    methods: {
        TeamSearch() {
                        this.loading = true
                        this.$http.post('/9api/projects-team/search', { project_id: this.projects_id, append: ['user', 'task_day_consume', 'wo_day_consume'] }).then(rps => {
                this.team = rps.data
                                this.loading = false
            })
        },
        TeamDelete(id) {
                        this.loading = true
                        this.$http.post('/9api/projects-team/delete', { project_id: this.projects_id, id: id }).then(rps => {
                this.TeamSearch()
            })
        },
        UserChange(users) {
                        this.loading = true
                        this.$http.post('/9api/projects-team/create', { project_id: this.projects_id, user_ids: users.map(item => item.id) }).then(rps => {
                this.TeamSearch()
            })
        },
                updateRole(id, role)
        {
            this.loading = true
            this.$http.post('/9api/pm/teams/update-role', { projects_id: this.projects_id, id: id, role: role }).then(rps => {
                this.TeamSearch()
            })
        }
    }
}
</script>